const ConversionCount = ({
    total = 0,
    pending = 0,
    processing = 0,
    failed = 0,
    success = 0,
} = {}) => ({
    total: Number(total),
    pending: Number(pending),
    processing: Number(processing),
    failed: Number(failed),
    success: Number(success),
});

const Status = ({
    feedListingAlias = '',
    manualListingAlias = '',
    dateCreatedTimestamp = null,
    dateUpdatedTimestamp = null,
    status = '',
} = {}) => ({
    feedListingAlias: String(feedListingAlias),
    manualListingAlias: String(manualListingAlias),
    dateCreatedTimestamp: Number(dateCreatedTimestamp),
    dateUpdatedTimestamp: Number(dateUpdatedTimestamp),
    status: String(status),
});

const ListingConversion = ({
    statuses = [],
    count = {},
} = {}) => ({
    statuses: statuses.map(Status),
    count: new ConversionCount(count),
});

export default ListingConversion;
